import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { Group } from "../../models/group.model";

let GroupInfoDialogComponent = {
    selector: "vcGroupInfoDialog",
    templateUrl: "/angular/components/group/group-info-dialog.component.html",
    bindings: {
        group: "=",
    },
    controller: class GroupInfoDialogController {
        // * bindings for typescript compiler *
        public group: Group;
        // ************************************
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        close(group: Group): void {
            this.dialog.hide(group);
        }
    },
};

angular
    .module("group")
    .component(GroupInfoDialogComponent.selector, GroupInfoDialogComponent);
